import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  noindex?: boolean;
  structuredData?: object;
}

export const SEO = ({
  title = "KopfAI - IA de Bem-Estar Mental",
  description = "KopfAI é um chat de IA direcionado ao bem-estar mental. Utilize princípios da Terapia Cognitivo-Comportamental (TCC) para entender seus pensamentos.",
  canonical = "https://kopfai.com/",
  ogType = "website",
  ogImage = "https://storage.googleapis.com/gpt-engineer-file-uploads/0yVLEnqFdhZtgwzlZOjLF7fKlmN2/social-images/social-1763671327922-share-image2.png",
  noindex = false,
  structuredData,
}: SEOProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="KopfAI" />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data */}
      {structuredData && <script type="application/ld+json">{JSON.stringify(structuredData)}</script>}
    </Helmet>
  );
};
